
/* finance */
export const GET_ACTIVITY_LOG_AUDITOR = "GET_ACTIVITY_LOG_AUDITOR";
export const GET_ACTIVITY_LOG_AUDITOR_SUCCESS = "GET_ACTIVITY_LOG_AUDITOR_SUCCESS";
export const GET_ACTIVITY_LOG_AUDITOR_FAIL = "GET_ACTIVITY_LOG_AUDITOR_FAIL";
